import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import Utilisateur from "./Utilisateur";
import Droit from "./Droit";
import Onglet from "./Onglet";
import { ADMIN_SERVER_BASE_URL, SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { setUtilisateur } from "../../store/userSlice";



export const dataOnglet = [
  { id: 0, libelle: "Utilisateur" },
  { id: 1, libelle: "Droit" }
]


const AppAdmin = () => {
  const dispatch = useDispatch();
  //hooks
  const [active, setActive] = useState(0)

  const renderContent = () => {
    if (active === 0) {
      return (<Utilisateur />)
    } else if (active === 1) {
      return (<Droit />)
    }
  }

  const getUsers = async () => {
    try {
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/listeUtilisateur");
      if (res.status === 1) {
        dispatch(setUtilisateur(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
    console.log("🚀 ~ file: index.tsx:39 ~ getUsers ~ error:", error)
    }
  };

  useEffect(() => {
    getUsers()
  }, []);


  return (
    <div
      style={{
        padding: 10,
        height: "80vh",
        overflow: "auto",
      }}
    >
      <Onglet
        active={active}
        setActive={setActive}
      />
      {renderContent()}
    </div>
  );
};
export default AppAdmin;
